import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "GroupEditV2" */ './lazyIndex'),
    { name: 'GroupEditV2' }
);

export const lazyEditGroupV2: LazyAction<typeof lazyIndex.editGroup, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.editGroup);
